'use client';

import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';

import store from '../../store';

interface ReduxProviderProps {
  children: ReactNode;
}

export function ReduxProvider({ children }: ReduxProviderProps): React.JSX.Element {
  return <Provider store={store}>{children}</Provider>;
}
